import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; 
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";       
import timeGridPlugin from "@fullcalendar/timegrid";     
import interactionPlugin from "@fullcalendar/interaction"; 
import Header from "../../components/header/header";
import "./CalendarStyles.css";
import { getWorkOrders } from "../../components/http";
import { useTranslation } from "react-i18next";

const CustomCalendar = ({ defaultView = "dayGridMonth" }) => {
  const [events, setEvents] = useState([]);
  const navigate = useNavigate(); 
  const { t } = useTranslation("");

  const fetchEvents = async (start, end) => {
    try {
      const response = await getWorkOrders({
        limit: 100,
        offset: 0,
        start_at__gte: start.toISOString(),
        end_at__lte: end.toISOString(),
      });

      if (!response) return;

      const formattedEvents = response.data.map((event) => ({
        id: event.id, 
        title: `${t("calendar.event.client")}: ${event.client.fullname} | ${t("calendar.event.car")}: ${event.car.model}`,
        start: new Date(event.start_at),
        end: new Date(event.end_at),
      }));

      setEvents(formattedEvents);
    } catch (error) {
      console.error(t("calendar.errors.loadingEvents"), error);
    }
  };

  const handleDatesSet = (dateInfo) => {
    console.log(t("calendar.logs.loadingEvents"), dateInfo.start, dateInfo.end);
    fetchEvents(dateInfo.start, dateInfo.end);
  };

  const handleEventClick = (clickInfo) => {
    const eventId = clickInfo.event.id;
    console.log(t("calendar.logs.eventClicked"), eventId); 
    if (eventId) {
      navigate(`/workOrders/${eventId}`);
    }
  };

  return (
    <div className="calendar-container">
      <Header title={t("calendar.title")} showImportExport={false} />

      <FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView={defaultView}
        headerToolbar={{
          left: "prev,next today",
          center: "title",
          right: "dayGridMonth,timeGridWeek,timeGridDay",
        }}
        events={events}
        datesSet={handleDatesSet}
        eventClick={handleEventClick}
        height="calc(100vh - 80px)"
      />
    </div>
  );
};

export default CustomCalendar;
